import { Button, Tooltip } from "antd";
import MaterialCreateCiqIcon from "components/svg-icons/material-create-ciq-icon";
import { MaterialExtractSpecType } from "pages/material-extracted-log/model";

const activeInlogCellRenderer = ({
  data,
  context
}: {
  data: MaterialExtractSpecType;
  context: any;
}) => {
  const isProjectArchived = !!context?.isProjectArchived;
  const createMaterialButton = (
    <Tooltip
      title={isProjectArchived ? null : "Create Material"}
      placement="left"
    >
      <Button
        key="extract_create_material"
        color="default"
        type="link"
        size="small"
        disabled={isProjectArchived}
        className="icon-link-arrow flex justify-center items-center"
        onClick={() => {
          context.onCreateMaterial?.(data);
        }}
      >
        <MaterialCreateCiqIcon
          size={16}
          className="fill-ciq-primary-900 cursor-pointer"
          opacity="1"
        />
      </Button>
    </Tooltip>
  );
  return data.grouped_parent?.length ? (
    <div className="flex justify-center items-center h-full space-x-2">
      <span className="px-1 py-1 text-xs text-ciq-black-a88 rounded border-ciq-gray-300 border border-solid bg-ciq-gray-300 bg-opacity-5 shadow-sm">
        Tracked
      </span>
      {createMaterialButton}
    </div>
  ) : (
    <div className="flex justify-end items-center h-full space-x-2">
      {createMaterialButton}
    </div>
  );
};

export default activeInlogCellRenderer;
